import { createApp } from 'vue';
import { vMaska } from 'maska';
import App from './App.vue';

createApp(App)
  .directive('maska', vMaska)
  .mount('#app');
